import { render } from "./App.vue?vue&type=template&id=68602ab0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=68602ab0&lang=css"

import exportComponent from "/Users/sergenorin/Desktop/Github/3ik-hayatglobalik-dergi-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__